import { createFileRoute } from "@tanstack/react-router";
import { Agents } from "../../../components/agents/agents";

export const Route = createFileRoute("/_app/agents/")({
  component: Agents
});
